/*
 * select.js
 * ---------
 * Exports the Select component.
 */

import React from "react";

import styles from "./select.module.scss";

export const Select = ({
  label,
  name,
  onChange,
  options,
  placeholder,
  value,
}) => (
  <div>
    <label className={styles.selectLabel} htmlFor={name}>
      {label}
    </label>

    <select
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      className={styles.select}
    >
      <option value="">{placeholder}</option>

      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);
